export enum VENUE_MANUAL_TAGS {
  VenuePlans = 'Venue',
  BrandPlans = 'Brand',
  Online = 'Online',
}
